module.exports = __webpack_public_path__ + "img/p1000.908669e7.jpg";